import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Partner", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kode Partner", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "User Id", -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "label-text required"
}, "Nomor Telepon", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "label-text required",
  for: "email"
}, "Email", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Keterangan", -1)
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_21 = { class: "container-btn-action" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  emits: ["reloadHeader"],
  setup(__props, { emit }: { emit: ({
  (e: 'reloadHeader'): void
}), expose: any, slots: any, attrs: any }) {

const moduleStore = 'hjpTable'
const endpoint = '/management/v2/Partners'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)
const userId = computed(() => store.state.userProfile.Id)

const initialValues = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Name : null,
  Code: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Code : null,
  UserId: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.MsUserId : null,
  PhoneNumber: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.PhoneNumber : null,
  Notes: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Notes : '',
  Email: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Email : null,
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Partner harus diisi!')
    .min(3, 'Nama Partner minimal 3 karakter')
    .max(50, 'Nama Partner tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Partner tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.noSpecialChar, 'Nama Partner tidak boleh menggunakan karakter spesial')
    .test('unique-name', 'Nama Partner sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Code: Yup.string()
    .required('Kode Partner harus diisi!')
    .min(3, 'Kode Partner minimal 3 karakter')
    .max(5, 'Kode Partner tidak boleh melebihi 5 karakter')
    .matches(rgxExp.notPrefixSpace, 'Kode Partner tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.notOnlySpecialChar, 'Kode Partner hanya boleh menggunakan huruf, angka, - dan _')
    .test('unique-name', 'Kode Partner sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['code']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Code === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Code
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  UserId: Yup.string()
    .required('User Id harus diisi!')
    .min(3, 'User Id minimal 1 karakter')
    .max(100, 'User Id maksimal 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'User Id tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.notOnlySpecialCharWithDot, 'User Id hanya boleh menggunakan huruf, angka, titik, - dan _')
    .test('unique-name', 'User Id sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['msUserId']
        })}`)
        // console.log('res', [res, val])
        const filterResult = res.result.filter((x: any) => x.MsUserId.toLowerCase() === val.toLowerCase())
        // console.log('filtered', filterResult)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.UserId
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  PhoneNumber: Yup.string()
    .min(11, 'Nomor Telepon minimal 11 karakter')
    .max(14, 'Nomor Telepon maksimal 14 karakter')
    .matches(rgxExp.phonePrefixZeroAndLocal, 'Nomor Telepon harus diawali angka 0 dan 62')
    .required('Nomor Telepon tidak boleh kosong')
    .test('unique-phonenumber', 'Nomor Telepon sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.PhoneNumber === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.PhoneNumber
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Email: Yup.string().required('Email tidak boleh kosong')
    .email('Gunakan format email yang benar')
    .max(100, 'Email maksimal 100 karakter')
    .test('unique-email', 'Email sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Email === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Email
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Notes: Yup.string()
    .max(255, 'Keterangan maksimal 255 karakter')
    .matches(rgxExp.notPrefixSpaceButCanNull, 'Keterangan tidak boleh hanya menggunakan spasi')
})



const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      Code: val.Code,
      Name: val.Name,
      Email: val.Email,
      PhoneNumber: val.PhoneNumber,
      RateLimit: 0,
      IsActive: val.IsActive,
      MsUserId: val.UserId,
      MsPassengerId: null,
      Notes: val.Notes
    }
  } else {
    dataForm.value = {
      Id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Id : '',
      Code: val.Code,
      Name: val.Name,
      Email: val.Email,
      PhoneNumber: val.PhoneNumber,
      RateLimit: 0,
      IsActive: val.IsActive,
      MsUserId: val.UserId,
      MsPassengerId: null,
      Notes: val.Notes
    }
  }
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.Id, dataForm.value)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Berhasil Ditambahkan' : 'Data Berhasil Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
    emit('reloadHeader')
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

const onlyNumber = (event: KeyboardEvent) => {
  const char = String.fromCharCode(event.which || event.keyCode)
  // Hanya izinkan 0–9
  if (!/^[0-9]$/.test(char)) {
    event.preventDefault()
  }
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Partner`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Masukkan nama partner",
                autocomplete: "off",
                maxlength: 50
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), { name: "Code" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Code,
                "onUpdate:modelValue": ($event: any) => ((values.Code) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary  ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Masukkan kode partner",
                autocomplete: "off",
                maxlength: 5,
                style: 'text-transform:uppercase'
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Code), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(Field), { name: "UserId" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.UserId,
                "onUpdate:modelValue": ($event: any) => ((values.UserId) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Masukkan user id",
                autocomplete: "off",
                maxlength: 100
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_9, _toDisplayString(errors.UserId), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(Field), { name: "PhoneNumber" }, {
            default: _withCtx(({ handleChange, handleBlur, field }) => [
              _createVNode(_unref(InputText), _mergeProps({
                class: `input-primary ${errors.PhoneNumber ? 'input-invalid' : ''}`,
                id: "phone"
              }, field, {
                "aria-describedby": "phone-help",
                placeholder: "Contoh: 081234567890",
                type: "tel",
                onChange: handleChange,
                onBlur: handleBlur,
                onKeypress: onlyNumber,
                minlength: 10,
                maxlength: 14
              }), null, 16, ["class", "onChange", "onBlur"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_12, _toDisplayString(errors.PhoneNumber), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_unref(Field), { name: "Email" }, {
            default: _withCtx(({ handleChange, handleBlur, field }) => [
              _createVNode(_unref(InputText), _mergeProps({
                class: `input-primary ${errors.Email ? 'input-invalid' : ''}`,
                id: "email"
              }, field, {
                "aria-describedby": "email-help",
                placeholder: "Contoh: jhon@email.com",
                onChange: handleChange,
                onBlur: handleBlur,
                minlength: 1,
                maxlength: 90
              }), null, 16, ["class", "onChange", "onBlur"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_15, _toDisplayString(errors.Email), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_unref(Field), {
            name: "Notes",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(Textarea), {
                id: "Notes",
                autocomplete: "nope",
                autoResize: true,
                ref: "addressRef",
                rows: "3",
                onChange: handleChange,
                onBlur: handleBlur
              }, null, 8, ["onChange", "onBlur"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_18, _toDisplayString(errors.Notes), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                inputId: "isactive"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})